import { render, staticRenderFns } from "./CustomerLoanAdvisoryReport.vue?vue&type=template&id=31a2041b"
import script from "./CustomerLoanAdvisoryReport.vue?vue&type=script&lang=js"
export * from "./CustomerLoanAdvisoryReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports